import icon_dashboard from './assets/icons/white_dashboard.svg';
import icon_sale from './assets/icons/white_sale.svg';
import icon_sale2 from './assets/icons/white_sale2.svg';
import icon_serve from './assets/icons/white_serve.svg';
import icon_appointment from './assets/icons/white_appointment.svg';
import icon_customer from './assets/icons/white_customer.svg';
import icon_commision from './assets/icons/white_commision.svg';
import icon_delivery from './assets/icons/white_delivery.svg';
import icon_inventory from './assets/icons/white_inventory.svg';
import icon_purchase from './assets/icons/white_purchase.svg';
import icon_supplychain from './assets/icons/white_supplychain.svg';
import icon_project from './assets/icons/white_project.svg';
import icon_expense from './assets/icons/white_expense.svg';
import icon_vendor from './assets/icons/white_vendor.svg';
import icon_cash from './assets/icons/white_cash.svg';
import icon_tax from './assets/icons/white_tax.svg';
// import icon_employee from './assets/icons/white_employee.svg';
import icon_profit_lost from './assets/icons/white_profit_lost.svg';
import icon_report from './assets/icons/white_report.svg';
import icon_setting from './assets/icons/white_setting.svg';
import icon_permision from './assets/icons/white_permision.svg';
import icon_account from './assets/icons/white_account.svg';
import icon_procedure from './assets/icons/white_procedure.svg';
import icon_table from './assets/icons/white_table.svg';
import icon_ticket from './assets/icons/white_ticket.svg';
// import icon_general_ledger from './assets/icons/white_general_ledger.svg';
import icon_payroll from './assets/icons/white_payroll.svg';
// import icon_safe_stock from './assets/icons/white_safe_stock.svg';

export default [
    {
        text: {
            vi: 'Bán hàng',
            en: 'Sale Order',
            fr: 'Commande vente',
            es: 'Pedido venta',
            id: 'Pesanan penjualan',
            ja: '販売注文',
            zh: '销售订单',
            ko: '판매 주문',
            hi: 'बिक्री आदेश',
            ar: 'أمر البيع'
        },
        icon: icon_sale,
        path: '/pos/AROrder',
        visible: {
            whenUserScreen: 'AROrders'
        }
    },
    // {
    //     text: {
    //         vi: 'Phục vụ',
    //         en: 'Serve'
    //     },
    //     path: '/pos/ARServeStatuse',
    //     icon: icon_table,
    //     visible: {
    //         whenUserScreen: 'ARServeStatuses'
    //     }
    // },
    {
        text: {
            vi: 'Chế biến',
            en: 'Cooking',
            fr: 'Cuisine',
            es: 'Cocina',
            id: 'Memasak',
            ja: '調理',
            zh: '烹饪',
            ko: '조리',
            hi: 'खाना बनाना',
            ar: 'الطبخ'
        },
        path: '/pos/ARServeCooking',
        icon: icon_serve,
        visible: {
            whenUserScreen: 'ARServeCookings'
        }
    },
    {
        text: {
            vi: 'Lên món',
            en: 'Delivery',
            fr: 'Livraison',
            es: 'Entrega',
            id: 'Pengiriman',
            ja: '配膳',
            zh: '上菜',
            ko: '서빙',
            hi: 'डिलीवरी',
            ar: 'التقديم'
        },
        path: '/pos/ARServeDelivery',
        icon: icon_serve,
        visible: {
            whenUserScreen: 'ARServeDeliveries'
        }
    },
    // {
    //     text: {
    //         vi: 'Dịch vụ',
    //         en: 'Service',
    //         fr: 'Service',
    //         es: 'Servicio',
    //         id: 'Layanan',
    //         ja: 'サービス',
    //         zh: '服务',
    //         ko: '서비스',
    //         hi: 'सेवा',
    //         ar: 'الخدمة'
    //     },
    //     path: '/pos/ARServeService',
    //     icon: icon_customer,
    //     visible: {
    //         whenUserScreen: 'ARServeServices'
    //     }
    // },
    // {
    //     text: {
    //         vi: 'Vận đơn',
    //         en: 'Transport'
    //     },
    //     icon: icon_delivery,
    //     path: '/pos/LGTransport',
    //     visible: {
    //         whenUserScreen: 'LGTransports'
    //     }
    // },
    // {
    //     text: {
    //         vi: 'Xuất Kho',
    //         en: 'Inventory Issue'
    //     },
    //     path: '/pos/ICIssue',
    //     icon: icon_inventory,
    //     visible: {
    //         whenUserScreen: 'ICIssues',
    //         whenSys: {
    //             use_Item_Good: 1
    //         }
    //     }
    // },
    // {
    //     text: {
    //         vi: 'Lịch hẹn',
    //         en: 'Appointment',
    //                     fr: 'Rendez-vous',
    //                     es: 'Cita',
    //                     id: 'Janji',
    //                     ja: '予約',
    //                     zh: '预约',
    //                     ko: '예약',
    //                     hi: 'नियुक्ति',
    //                     ar: 'موعد'
    //     },
    //     path: '/pos/ARAppointment',
    //     icon: icon_appointment,
    //     visible: {
    //         whenUserScreen: 'ARAppointments'
    //     }
    // },
    // {
    //     text: {
    //         vi: 'Đặt phòng',
    //         en: 'Room Booking'
    //     },
    //     icon: icon_appointment,
    //     path: '/pos/ARRentalRoomBooking',
    //     visible: {
    //         whenUserScreen: 'ARRentalRoomBookings'
    //     }
    // },
    // {
    //     text: {
    //         vi: 'Khách Tiềm Năng',
    //         en: 'Lead'
    //     },
    //     path: '/pos/CRMLead',
    //     icon: icon_customer,
    //     visible: {
    //         whenUserScreen: 'CRMLeads'
    //     }
    // },
    // {
    //     text: {
    //         vi: 'Xuất nguyên liệu',
    //         en: 'Issue Serving Material'
    //     },
    //     icon: icon_inventory,
    //     path: '/pos/ARServeMaterialIssue',
    //     visible: {
    //         whenUserScreen: 'ARServeMaterialIssues'
    //     }
    // },
    // {
    //     text: {
    //         vi: 'Nạp tiền',
    //         en: 'Deposit',
    //         fr: 'Dépôt',
    //         es: 'Depósito',
    //         id: 'Deposit',
    //         ja: '預金',
    //         zh: '押金',
    //         ko: '보증금',
    //         hi: 'जमा',
    //         ar: 'إيداع'
    //     },
    //     path: '/pos/WalletTran',
    //     icon: icon_cash,
    //     visible: {
    //         whenUserScreen: 'WalletTrans'
    //     }
    // },
    {
        text: {
            vi: 'Chấm công',
            en: 'Attendance',
            fr: 'Présence',
            es: 'Asistencia',
            id: 'Kehadiran',
            ja: '出勤',
            zh: '出勤',
            ko: '출근',
            hi: 'उपस्थिति',
            ar: 'الحضور'
        },
        icon: icon_payroll,
        path: '/pos/HRWorkingAttendance',
        visible: {
            whenUserScreen: 'HRAttendanceQRDisplay'
        }
    },
    {
        text: {
            vi: 'QR Thanh Toán',
            en: 'Billing QRCode',
            fr: 'QRCode facturation',
            es: 'Código QR facturación',
            id: 'QRCode tagihan',
            ja: '請求QRコード',
            zh: '账单二维码',
            ko: '청구 QR코드',
            hi: 'बिलिंग QRCode',
            ar: 'رمز QR للفوترة'
        },
        icon: icon_payroll,
        path: '/pos/AROrderBilling',
        visible: {
            whenUserScreen: 'AROrderBilling'
        }
    },
    {
        text: {
            vi: 'Sổ tiền mặt',
            en: 'Cash Book',
            fr: 'Livre de caisse',
            es: 'Libro de caja',
            id: 'Buku Kas',
            ja: '現金出納帳',
            zh: '现金账簿',
            ko: '현금출납부',
            hi: 'नकद बही',
            ar: 'دفتر النقدية'
        },
        icon: icon_cash,
        path: '/pos/POSCashBook',
        visible: {
            whenSession: { manages_work_shift: 1 }
        }
    }
];
